import { useHealthPlanContext } from '../../../Services/HealthPlanContext';
import { HealthPlanCode } from '../../../Enums/HealthPlanCode.enum';

export default function useHealthPlan() {
	const { healthPlan } = useHealthPlanContext();

	const isBaby = healthPlan?.code === HealthPlanCode.BABY;
	const isDiabetes = healthPlan?.code === HealthPlanCode.DIABETES;

	return {
		isBaby,
		isDiabetes,
		healthPlanCode: isBaby
			? HealthPlanCode.BABY
			: isDiabetes
			? HealthPlanCode.DIABETES
			: null,
	};
}
